import { render, staticRenderFns } from "./ThreatVuln.vue?vue&type=template&id=4d464ade&scoped=true&"
import script from "./ThreatVuln.vue?vue&type=script&lang=js&"
export * from "./ThreatVuln.vue?vue&type=script&lang=js&"
import style0 from "./ThreatVuln.vue?vue&type=style&index=0&id=4d464ade&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d464ade",
  null
  
)

export default component.exports